import Icon from "./icon.vue";
import Input from "./input.vue";
export default {
  name: "EditableField",
  components: {
    Icon,
    Input
  },

  data() {
    return {
      currentState: "display"
    };
  },

  props: {
    modelValue: [String, Number, Boolean],
    type: String
  },
  computed: {
    propModel: {
      get() {
        return this.modelValue;
      },

      set(value) {//this.$emit('update:modelValue', value)
      }

    }
  },
  methods: {
    onInput(ev) {//this.$emit("update:modelValue", this.modelValue);
      //this.$emit("update:modelValue", ev.target.value);
    },

    onBlur() {
      this.currentState = "display";
      this.$emit("blur");
    },

    switchToEdit() {
      this.currentState = "edit";
      this.$nextTick(() => this.$refs.input.focus());
    }

  }
};